module.exports = __webpack_public_path__ + "media/packs/compcalc/components/icons/life-exp-915351d30250c61ec1367895d92b59a0.png";